import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estudos-vellocar',
  templateUrl: './estudos-vellocar.component.html',
  styleUrls: ['./estudos-vellocar.component.css']
})
export class EstudosVellocarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
